module.exports = __webpack_public_path__ + "static/media/COINS_tab_active@3x.5fec0733.png";